<template>
    <CRow>
        <CCol col>
            <ejs-grid ref='grid' :dataSource="groupData" :allowFiltering='true' :commandClick='commandClick' :allowPaging="true" 
                      :allowResizing='true' :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' 
                      :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' 
                      :pageSettings='pageSettings' :actionComplete='actionComplete' :actionBegin="actionBegin"
                      :actionFailure="actionFailure" :filterSettings='filterOptions' :queryCellInfo='queryCellInfo'>
                <e-columns>
                    <e-column field='userGroupId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                    <e-column field='name' headerText='Group Name' :validationRules="requiredRules" width=120></e-column>
                    <e-column headerText='Actions' width=50  textAlign='left' :commands='commands'></e-column>
                </e-columns>
            </ejs-grid>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn} from "@syncfusion/ej2-vue-grids";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import urls from '../../../common/urls'
    import apis from '../../../common/network'
    import gridOptions from '../../../common/gridOptions'
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import Router from 'vue-router'
    import store from '../../../store';
    import router from '../../../router';
    import usersData from "../../users/UsersData";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(Router)
    Vue.use(ButtonPlugin); 
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);

    Vue.use(GridPlugin);

    export default {
        name: 'groupsAndPermissionsForm',
        components: {
        },
        created() {
            this.getTakenUserGroups();
        },
        data() {
            return {
                store: store,
                router: router,
                userData: [],
                groupData: SyncHelper.getDataManager("UserGroups"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.UserGroups.Update"],
                    allowAdding: store.state.permissions["Permissions.UserGroups.Create"],
                    allowDeleting: store.state.permissions["Permissions.UserGroups.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                requiredRules: { required: true, maxLength: 256 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,
                commands: [{ buttonOption: { cssClass: 'secondary', content: 'Permissions', disabled: false } },
                    { buttonOption: { cssClass: 'e-primary custombutton', content: 'Clone', disabled: !store.state.permissions["Permissions.UserGroups.Create"]} }] ,
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            cloneData: (args, grid) => {
                apis.protectedApi(`${urls.apiBaseUrl}UserGroups/CloneGroupPermissions/${args}`).then(it => {
                       
                            gridOptions.infoAlert("clone group created: " + it.data.name);
                            grid.refresh();
                       
                    }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
            queryCellInfo: function (args) {
                if (args.column.headerText === 'Actions' && args.data.name === "System Administrator") {
                    args.cell.querySelector('.custombutton').ej2_instances[0].disabled = true
                }
            },
            getTakenUserGroups: function () {
                apis.protectedApi(`${urls.apiBaseUrl}User`).then(it => {
                    this.userData = it.data.result;
                }).catch(
                    response => {
                        gridOptions.errorAlert("Error invoking service,please contact support");
                    }
                );
            },
            commandClick: function (args) {
                var groupId = args.rowData.userGroupId;
                if (args.commandColumn.buttonOption.content == "Permissions") {// permissions command button
                    router.push({ name: 'Group Permission', params: { groupId: groupId } });
                }
                if (args.commandColumn.buttonOption.content == "Clone") {// clone command button
                    this.cloneData(groupId, this.$refs.grid);
                }
            },
           
            toolbarClick(args) {
                gridOptions.excelExport(args, "User Groups.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["name"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
            },
            actionBegin(args) {

                if (args.requestType == 'save') {
   
                    showSpinner(document.getElementById('mainSpinner'));


                }
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType === 'delete') {
                    if (this.userData.find(s => s.userGroupName === args.data[0].name)) {
                        gridOptions.infoAlert(`This group is currently assigned to a User and cannot be deleted.`);
                        args.cancel = true;
                        return;
                    }
                    if (args.data[0].name === "System Administrator") {
                        gridOptions.infoAlert(`System Administrator Group cannot be edited nor deleted.`);
                        args.cancel = true;
                        return;
                    }
                    if (args.data[0].name === "MyAlfe") {
                        gridOptions.infoAlert(`MyAlfe Group cannot be edited nor deleted.`);
                        args.cancel = true;
                        return;
                    }
                }
                if (args.requestType === 'beginEdit') {
                    if (args.rowData.name === "System Administrator") {
                        gridOptions.infoAlert(`System Administrator Group cannot be edited nor deleted.`);
                        args.cancel = true;
                        return;
                    }
                    if (args.rowData.name === "MyAlfe") {
                        gridOptions.infoAlert(`MyAlfe Group cannot be edited nor deleted.`);
                        args.cancel = true;
                        return;
                    }
                }
                gridOptions.actionBegin(args);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn]
        }
    };

</script>
<style>
    .required-input.e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
    }
</style>
